(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initHeroBannerSlider();
    initLifestyleSlider();
    initProductGallery();
    initCartDrawer();
    initVariantPicker();
    initMobileNav();
  }

  /* Mobile Navigation */
  function initMobileNav() {
    const nav = document.getElementById('GalaNav');
    if (!nav) return;

    document.querySelectorAll('.js-nav-open').forEach(btn => {
      btn.addEventListener('click', () => nav.classList.add('is-open'));
    });

    document.querySelectorAll('.js-nav-close').forEach(btn => {
      btn.addEventListener('click', () => nav.classList.remove('is-open'));
    });

    // Close nav when a link is clicked (mobile)
    nav.querySelectorAll('.gala-nav-link').forEach(link => {
      link.addEventListener('click', () => nav.classList.remove('is-open'));
    });
  }

  /* Hero Banner Slider */
  function initHeroBannerSlider() {
    const container = document.querySelector('.gala-hero-banner');
    if (!container) return;

    const track = container.querySelector('.gala-hero-banner-track');
    const slides = container.querySelectorAll('.gala-hero-banner-slide');
    const prevBtn = container.querySelector('.gala-hero-banner-btn-prev');
    const nextBtn = container.querySelector('.gala-hero-banner-btn-next');
    const dots = container.querySelectorAll('.gala-hero-banner-dot');

    if (slides.length <= 1) return;
    let currentIndex = 0;

    function updateSlide(index) {
      currentIndex = (index + slides.length) % slides.length;
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    prevBtn?.addEventListener('click', () => updateSlide(currentIndex - 1));
    nextBtn?.addEventListener('click', () => updateSlide(currentIndex + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => updateSlide(i)));

    // Auto advance every 6 seconds
    let autoTimer = setInterval(() => updateSlide(currentIndex + 1), 6000);
    container.addEventListener('mouseenter', () => clearInterval(autoTimer));
    container.addEventListener('mouseleave', () => {
      autoTimer = setInterval(() => updateSlide(currentIndex + 1), 6000);
    });

    // Touch/swipe support
    let touchStartX = 0;
    container.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    container.addEventListener('touchend', (e) => {
      const touchEndX = e.changedTouches[0].clientX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        updateSlide(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
    }, { passive: true });
  }

  /* Lifestyle Slider */
  function initLifestyleSlider() {
    const container = document.querySelector('.gala-slider-section');
    if (!container) return;

    const track = container.querySelector('.gala-slider-track');
    const slides = container.querySelectorAll('.gala-slide');
    const prevBtn = container.querySelector('.gala-slider-btn-prev');
    const nextBtn = container.querySelector('.gala-slider-btn-next');
    const dots = container.querySelectorAll('.gala-slider-dot');

    if (!track || slides.length === 0) return;
    let currentIndex = 0;

    function getSlidesPerView() {
      if (window.innerWidth <= 600) return 1;
      if (window.innerWidth <= 900) return 2;
      return 3;
    }

    function updateSlide(index) {
      const spv = getSlidesPerView();
      const maxIndex = Math.max(0, slides.length - spv);
      currentIndex = Math.min(Math.max(0, index), maxIndex);
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      const slideWidth = slides[0].getBoundingClientRect().width + gap;
      track.style.transform = `translateX(-${currentIndex * slideWidth}px)`;

      dots.forEach((dot, i) => {
        dot.style.display = i > maxIndex ? 'none' : '';
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    prevBtn?.addEventListener('click', () => updateSlide(currentIndex - 1));
    nextBtn?.addEventListener('click', () => updateSlide(currentIndex + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => updateSlide(i)));
    window.addEventListener('resize', () => updateSlide(currentIndex));

    // Touch/swipe support
    let touchStartX = 0;
    const viewport = container.querySelector('.gala-slider-viewport');
    if (viewport) {
      viewport.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
      viewport.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].clientX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          updateSlide(diff > 0 ? currentIndex + 1 : currentIndex - 1);
        }
      }, { passive: true });
    }
    
    // Trigger initial state
    updateSlide(0);
  }

  /* Product Gallery */
  function initProductGallery() {
    const gallery = document.querySelector('.gala-gallery');
    if (!gallery) return;

    const mainImg = gallery.querySelector('.gala-gallery-main-image');
    const thumbs = gallery.querySelectorAll('.gala-thumb-shot');

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const fullSrc = thumb.getAttribute('data-full-src');
        if (mainImg && fullSrc) {
          mainImg.src = fullSrc;
          thumbs.forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        }
      });
    });
  }

  /* Ajax Cart Drawer */
  function initCartDrawer() {
    const drawer = document.getElementById('GalaCartDrawer');
    const overlay = document.getElementById('GalaCartOverlay');
    const triggers = document.querySelectorAll('.js-cart-trigger');
    const closeBtns = document.querySelectorAll('.js-cart-close');

    function openCart() {
      drawer?.classList.add('is-active');
      overlay?.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      refreshCart();
    }

    function closeCart() {
      drawer?.classList.remove('is-active');
      overlay?.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    triggers.forEach(btn => btn.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
    }));

    closeBtns.forEach(btn => btn.addEventListener('click', closeCart));
    overlay?.addEventListener('click', closeCart);

    // Escape key closes cart
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer?.classList.contains('is-active')) {
        closeCart();
      }
    });

    // Global listener for Add To Cart forms
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const submitBtn = form.querySelector('button[type="submit"]');
        const originalText = submitBtn?.textContent;

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding...';
        }

        const formData = new FormData(form);
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
          if (response.ok) {
            openCart();
          } else {
            console.error('Error adding item to cart');
          }
        } catch (err) {
          console.error('Cart add exception:', err);
        } finally {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        }
      });
    });
  }

  /* Variant Picker */
  function initVariantPicker() {
    // Handled inline in main-product.liquid via selectVariant / changeQty
  }

  /* Refresh Cart */
  window.refreshCart = async function() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      // Update badge count
      document.querySelectorAll('.js-cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.toggle('is-hidden', cart.item_count === 0);
      });

      const listEl = document.getElementById('GalaCartItemsList');
      const totalEl = document.getElementById('GalaCartTotalPrice');
      if (!listEl) return;

      if (cart.items.length === 0) {
        listEl.innerHTML = `
          <div class="gala-cart-empty">
            <p>Your bag is empty.</p>
            <a href="/collections/all" class="gala-btn gala-btn-primary">Explore Collection</a>
          </div>`;
        if (totalEl) totalEl.textContent = '$0.00';
        return;
      }

      if (totalEl) {
        totalEl.textContent = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency || 'USD' });
      }

      listEl.innerHTML = cart.items.map(item => `
        <div class="gala-cart-item" data-key="${item.key}">
          <div class="gala-cart-thumb">
            <img src="${item.image}" alt="${item.product_title}">
          </div>
          <div class="gala-cart-copy">
            <h3>${item.product_title}</h3>
            ${item.variant_title !== 'Default Title' ? `<p>${item.variant_title}</p>` : ''}
            <p>${(item.final_line_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency || 'USD' })}</p>
          </div>
          <div class="gala-cart-actions">
            <div class="gala-stepper">
              <button type="button" onclick="updateCartItem('${item.key}', ${item.quantity - 1})" class="gala-icon-button" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" onclick="updateCartItem('${item.key}', ${item.quantity + 1})" class="gala-icon-button" aria-label="Increase quantity">+</button>
            </div>
          </div>
        </div>
      `).join('');
    } catch (err) {
      console.error('Error refreshing cart:', err);
    }
  };

  window.updateCartItem = async function(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      });
      refreshCart();
    } catch (err) {
      console.error('Error updating cart line item:', err);
    }
  };

})();
